import { IconWrapper, type IconProps } from '../SlideTypeIcon';

export const GoogleSlidesIcon = ({ size }: IconProps) => (
  <IconWrapper size={size}>
    <path
      d="M18.0938 4H8.66406C7.74883 4 7 4.74883 7 5.66406V26.7422C7 27.6574 7.74883 28.4063 8.66406 28.4063H23.0859C24.0012 28.4063 24.75 27.6574 24.75 26.7422V10.6562L20.8672 7.88281L18.0938 4Z"
      fill="#F4B400"
    />
    <path
      d="M19.4805 15.0938H12.2695C11.8119 15.0938 11.4375 15.4682 11.4375 15.9258V23.1367C11.4375 23.5943 11.8119 23.9687 12.2695 23.9687H19.4805C19.9381 23.9687 20.3125 23.5943 20.3125 23.1367V15.9258C20.3125 15.4682 19.9381 15.0938 19.4805 15.0938ZM19.2031 21.4727H12.5469V17.5898H19.2031V21.4727Z"
      fill="#F1F1F1"
    />
    <path
      d="M18.0938 4V8.99219C18.0938 9.91158 18.8384 10.6562 19.7578 10.6562H24.75L18.0938 4Z"
      fill="#FADA80"
    />
    <path
      d="M18.0938 4V4.13867L24.6113 10.6562H24.75L18.0938 4Z"
      fill="white"
      fillOpacity="0.1"
    />
    <path
      d="M8.66406 4C7.74883 4 7 4.74883 7 5.66406V5.80273C7 4.8875 7.74883 4.13867 8.66406 4.13867H18.0938V4H8.66406Z"
      fill="white"
      fillOpacity="0.2"
    />
    <path
      d="M23.0859 28.2676H8.66406C7.74883 28.2676 7 27.5187 7 26.6035V26.7422C7 27.6574 7.74883 28.4063 8.66406 28.4063H23.0859C24.0012 28.4063 24.75 27.6574 24.75 26.7422V26.6035C24.75 27.5187 24.0012 28.2676 23.0859 28.2676Z"
      fill="#BF360C"
      fillOpacity="0.2"
    />
  </IconWrapper>
);
